export const mockedTransactions = [
  {
    id: '3213',
    title: 'Payment',
    description: 'Payment for the service',
    amount: 100,
    date: '2021-09-01',
    type: 'Income',
  },
  {
    id: '4324234',
    title: 'Payment',
    description: 'Payment for the service',
    amount: 10430,
    date: '2021-09-05',
    type: 'Income',
  },
]

// `title` es el label que se muestra; `path` es la ruta. Antes la ruta salia de
// title.toLowerCase(), asi que el label estaba atado al path y no se podia
// renombrar "Agenda" sin romper el routing. Ahora van separados.
export const menus = [
  {
    id: '1',
    title: 'Home',
    path: '/home',
    icon: 'House',
  },
  {
    id: '2',
    title: 'Transactions',
    path: '/transactions',
    icon: 'Receipt',
  },
  {
    id: '3',
    title: 'Wallets',
    path: '/wallets',
    icon: 'Wallet',
  },
  {
    id: '4',
    title: 'Contacts',
    path: '/agenda',
    icon: 'AddressBook',
  },
]

export const typeTransactions = [
  // { value: "All", label: "All" },
  // { value: "Payoneer", label: "Payoneer" },
  { value: 'Portal', label: 'Portal' },
  // { value: "Tenui", label: "Tenui", disabled: true },
]

export const coins = [
  {
    value: 'USDC',
    label: 'USDC',
    disabled: false,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png',
  },
  {
    value: 'POL',
    label: 'POL',
    disabled: false,
    icon: 'https://assets.coingecko.com/coins/images/32440/standard/pol.png?1759114181',
  },
  {
    value: 'USDT',
    label: 'USDT',
    disabled: false,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether.png',
  },
  {
    value: 'TRX',
    label: 'TRX',
    disabled: false,
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png',
  },
]

export const networks = [
  {
    value: 'POLYGON',
    label: 'Polygon',
    disabled: false,
    icon: 'https://assets.coingecko.com/coins/images/32440/standard/pol.png?1759114181',
  },
  {
    value: 'TRON',
    label: 'Tron',
    disabled: false,
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png',
  },
]

export const mockedCryptoToBuy = [
  {
    id: 'btc',
    name: 'Bitcoin',
    symbol: 'BTC',
    price: 48600,
    change24h: 2.3,
    icon: 'https://cryptologos.cc/logos/bitcoin-btc-logo.png',
  },
  {
    id: 'eth',
    name: 'Ethereum',
    symbol: 'ETH',
    price: 2600,
    change24h: -1.2,
    icon: 'https://cryptologos.cc/logos/ethereum-eth-logo.png',
  },
  {
    id: 'sol',
    name: 'Solana',
    symbol: 'SOL',
    price: 98,
    change24h: 3.7,
    icon: 'https://cryptologos.cc/logos/solana-sol-logo.png',
  },
]

export const chainIds = [
  { name: 'Ethereum', value: 'eip155:1' },
  { name: 'Polygon', value: 'eip155:137' },
  { name: 'Base', value: 'eip155:8453' },
]

export const mockedTokensIcons = [
  {
    name: 'USDC',
    logo: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png',
  },
  {
    name: 'USDT',
    logo: 'https://assets.coingecko.com/coins/images/325/small/Tether.png',
  },
  {
    name: 'POL',
    logo: 'https://assets.coingecko.com/coins/images/32440/standard/pol.png?1759114181',
  },
  {
    name: 'MATIC',
    logo: 'https://assets.coingecko.com/coins/images/32440/standard/pol.png?1759114181',
  },
  {
    name: 'TRX',
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png',
  },
]
